import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: row;
	gap: 1.5rem;
	overflow: auto;

	@media (max-width: 1100px) {
		flex-direction: column;
	}
`;
